import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../App.css"; // Assuming a shared CSS file for consistent styling

const CountrySelector = () => {
    const [country, setCountry] = useState('');
    const [manualCountry, setManualCountry] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        // Use manual country if "Other" is selected
        const selectedCountry = country === 'Other' ? manualCountry : country;

        if (selectedCountry) {
            localStorage.setItem('selectedCountry', selectedCountry);
            navigate('/register'); // Redirect to the registration page
        } else {
            alert('Please select or enter a country.');
        }
    };

    return (
        <div
            className="page-container"
            style={{
                backgroundImage: `url(${require('../assets/images/landing_background.jpg')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '100vh',
                fontFamily: 'Montserrat, sans-serif',
            }}
        >
            <header className="page-header">
                <div className="logo">
                    <img
                        src={require('../assets/images/logo_name.PNG')}
                        alt="YourStoryWorld Logo"
                        style={{ height: '50px', cursor: 'pointer' }}
                        onClick={() => navigate('/')}
                    />
                </div>
                <nav style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={() => navigate('/')}
                        className="header-button"
                    >
                        Home
                    </button>
                    <button
                        onClick={() => navigate('/help')}
                        className="header-button"
                    >
                        Help
                    </button>
                </nav>
            </header>

            <main className="page-content" style={{ textAlign: 'center', padding: '20px' }}>
                <div
                    style={{
                        background: 'rgba(255, 255, 255, 0.9)',
                        padding: '30px',
                        borderRadius: '10px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        display: 'inline-block',
                        textAlign: 'center',
                    }}
                >
                    <h1 style={{ fontFamily: 'Montserrat, sans-serif', color: '#007BFF' }}>Select Your Country</h1>
                    <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '10px' }}>
                            Choose your country:
                        </label>
                        <select
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            required
                            style={{
                                margin: '10px 0',
                                padding: '10px',
                                borderRadius: '5px',
                                border: '1px solid #ccc',
                                width: '100%',
                                maxWidth: '300px',
                            }}
                        >
                            <option value="">-- Select --</option>
                            <option value="UK">United Kingdom</option>
                            <option value="US">United States</option>
                            <option value="CA">Canada</option>
                            <option value="AU">Australia</option>
                            <option value="IN">India</option>
                            <option value="Other">Other</option>
                        </select>
                        {country === 'Other' && (
                            <input
                                type="text"
                                value={manualCountry}
                                onChange={(e) => setManualCountry(e.target.value)}
                                placeholder="Enter your country"
                                required
                                style={{
                                    marginTop: '10px',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc',
                                    width: '100%',
                                    maxWidth: '300px',
                                }}
                            />
                        )}
                        <button
                            type="submit"
                            className="submit-button"
                            style={{
                                marginTop: '20px',
                                padding: '10px 20px',
                                backgroundColor: '#1976D2',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px',
                            }}
                        >
                            Next
                        </button>
                    </form>
                </div>
            </main>

            <footer className="page-footer">
                <p>&copy; {new Date().getFullYear()} YourStoryWorld. All rights reserved.</p>
                <nav style={{ marginTop: '10px' }}>
                    <a href="/about" className="footer-link">About Us</a>
                    <a href="/contact" className="footer-link">Contact</a>
                </nav>
            </footer>
        </div>
    );
};

export default CountrySelector;
